import { HomeOutlined, CameraOutlined, BarChartOutlined, SettingOutlined } from '@ant-design/icons';
import { SidebarItem } from '_/components/common/layout/AppSidebar';
import { useCollection } from '_/contexts/CollectionContext';
import { useOrganization } from '_/contexts/OrganizationContext';
import { useProject } from '_/contexts/ProjectContext';
import { useSourceContext } from '_/contexts/SourceContext';
import React, { useMemo } from 'react';

// Create icon elements once to prevent re-renders
const homeIcon = <HomeOutlined />;
const cameraIcon = <CameraOutlined />;
const barChartIcon = <BarChartOutlined />;
const settingIcon = <SettingOutlined />;

export function useSourceSidebarItems(): SidebarItem[] {
  const { selectedOrgSlug } = useOrganization();
  const { selectedProjectSlug } = useProject();
  const { selectedCollectionSlug } = useCollection();
  const { selectedSourceSlug } = useSourceContext();

  return useMemo(
    () => [
      {
        icon: homeIcon,
        text: 'Source Home',
        href: `/orgs/${selectedOrgSlug}/projects/${selectedProjectSlug}/collections/${selectedCollectionSlug}/sources/${selectedSourceSlug}/home`,
      },
      {
        icon: cameraIcon,
        text: 'Snapshots',
        href: `/orgs/${selectedOrgSlug}/projects/${selectedProjectSlug}/collections/${selectedCollectionSlug}/sources/${selectedSourceSlug}/snapshots`,
      },
      {
        icon: barChartIcon,
        text: 'Graphs',
        href: `/orgs/${selectedOrgSlug}/projects/${selectedProjectSlug}/collections/${selectedCollectionSlug}/sources/${selectedSourceSlug}/graphs`,
      },
      {
        icon: settingIcon,
        text: 'Settings',
        href: `/orgs/${selectedOrgSlug}/projects/${selectedProjectSlug}/collections/${selectedCollectionSlug}/sources/${selectedSourceSlug}/settings`,
      },
    ],
    [selectedOrgSlug, selectedProjectSlug, selectedCollectionSlug, selectedSourceSlug],
  );
}
